<template>
  <div>
    <el-select :value="value" value-key="key" :size="size" @input="change($event)" :clearable="true">
      <el-option label="主套餐" value="main" />
      <el-option label="加油包" value="auxi" />
    </el-select>
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  props: ['value', 'size', 'showAllTip', 'showAllTipLabel'],
  methods: {
    change: function (val) {
      this.$emit('input', val)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/card/components/PackageTypeSelect.vue